import angular from 'angular';

let RolesFactory = angular.module('RolesFactory', [])
.factory('RolesFactory', ($rootScope, $http, HttpFactory, URLS) => {
	'ngInject';
	return {
		getAll: (params) => {
			let parameters = Object.assign({}, params);
			return HttpFactory.get(URLS.ROLES, parameters);
		},
		getAllPermissions: () => {
			return HttpFactory.get(URLS.PERMISSIONS);
		},
		getOne: (roleId) => {
			let url = URLS.ROLES + "/" + roleId;
			return HttpFactory.get(url);
		},
		create: (data) => {
			return HttpFactory.post(URLS.ROLES, data);
		},
		update: (roleId, data) => {
			let url = URLS.ROLES + "/" + roleId;
			return HttpFactory.put(url, data);
		},
		delete: (roleId) => {
			let url = URLS.ROLES + "/" + roleId;
			return HttpFactory.delete(url);
		}
	};
}).name;

export default RolesFactory;



// WEBPACK FOOTER //
// ./client/app/services/roles.factory.js